import { useEffect } from "react";
import { BUSINESS } from "@/constants";

export default function PrivacyPolicyPage() {
    useEffect(() => {
        document.title = `Privacy Policy | ${BUSINESS.name}`;
        window.scrollTo(0, 0);
        return () => {
            document.title = "Dirt Cheapest Sod Corp | Sod & Ornamental Nursery — Boynton Beach, FL";
        };
    }, []);

    return (
        <main data-testid="privacy-policy-page" className="py-16 sm:py-24">
            <div className="max-w-3xl mx-auto px-4 sm:px-6">
                <h1 className="font-heading font-bold tracking-tight text-primary text-4xl sm:text-5xl">
                    Privacy Policy
                </h1>
                <p className="mt-4 text-sm text-muted-foreground">Last updated: July 2026</p>

                <div className="mt-10 space-y-8 text-base leading-relaxed text-foreground">
                    <section>
                        <h2 className="font-heading font-semibold text-lg text-primary">
                            Introduction
                        </h2>
                        <p className="mt-3">
                            {BUSINESS.name} ("we", "our", or "the company") operates this
                            website. This Privacy Policy explains what information we collect
                            through this website and how it is used.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-heading font-semibold text-lg text-primary">
                            Information We Collect
                        </h2>
                        <p className="mt-3">
                            If you submit the contact form on this website, we collect the
                            information you provide: your name, email address, and the content
                            of your message. We do not collect payment information or create
                            user accounts on this website.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-heading font-semibold text-lg text-primary">
                            How We Use Your Information
                        </h2>
                        <p className="mt-3">
                            Information submitted through the contact form is used solely to
                            respond to your enquiry. We do not sell, rent, or share your
                            personal information with third parties for marketing purposes.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-heading font-semibold text-lg text-primary">
                            Data Retention
                        </h2>
                        <p className="mt-3">
                            Contact form submissions are retained only as long as needed to
                            respond to your enquiry and for reasonable business record-keeping.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-heading font-semibold text-lg text-primary">
                            Contact
                        </h2>
                        <p className="mt-3">
                            If you have questions about this Privacy Policy, you can reach us
                            through the contact form on this website or by mail at:
                        </p>
                        <p data-testid="privacy-address" className="mt-3 text-muted-foreground">
                            {BUSINESS.name}
                            <br />
                            {BUSINESS.addressLines[0]}
                            <br />
                            {BUSINESS.addressLines[1]}
                        </p>
                    </section>
                </div>
            </div>
        </main>
    );
}
